import { defineStore } from "pinia";
import { ref } from "vue";

export const useLoadingStore = defineStore("loading", () => {
    const isLoadingVisible = ref<boolean>(false);

    function toggle(value: boolean) {
        isLoadingVisible.value = value;
    }

    function asRef() {
        return isLoadingVisible;
    }

    return { isLoadingVisible, toggle, asRef };
});
